var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-box search-box-navbar"},[_c('div',{staticClass:"container mx-auto"},[_c('app-search-form-more-days',{attrs:{"loading":_vm.loading,"searchType":2,"isFlat":true,"on-destinations-page":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }